/**
 * Releases Layout
 *
 * @module features/releases/pages/ReleasesLayout
 * @description Layout host for the Release QA feature. Application
 * navigation now lives in the breadcrumb dropdown (see
 * `ReleasePropertyTimeline`'s `usePropertyBreadcrumbs` call) rather than a
 * subnav column, so this is a bare outlet host.
 *
 * @see docs/api/services/release-qa.md
 */

import { Outlet } from '@tanstack/react-router';

export function ReleasesLayout() {
  return <Outlet />;
}
